export default __webpack_public_path__ + "static/media/THERMAL_FORMAT_2.071d541d.png";